import { hasAnyRewardsAccess } from "@ticketon/rewards-core";

/**
 * Rewards admin permissions (`Travel:Rewards:*`, Ticketon.Rewards README §5). The values
 * match `RewardsPermission` in rewards-core, which the rewards UI package checks. Frontend
 * checks are UX only; the backend enforces every operation.
 */
export enum RewardsPermissions {
  ALL = "Travel:Rewards:*",
  VIEW = "Travel:Rewards:View",
  MANAGE_PROGRAMS = "Travel:Rewards:ManagePrograms",
  MANAGE_RULES = "Travel:Rewards:ManageRules",
  MANAGE_CATALOG = "Travel:Rewards:ManageCatalog",
  VIEW_MEMBERS = "Travel:Rewards:ViewMembers",
  ADJUST_POINTS = "Travel:Rewards:AdjustPoints",
  MANAGE_REDEMPTIONS = "Travel:Rewards:ManageRedemptions",
  VIEW_AUDIT = "Travel:Rewards:ViewAudit",
}

/** Whether the granted permission set opens the rewards module at all. */
export function hasRewardsAccess(userPermissions: readonly string[]): boolean {
  return hasAnyRewardsAccess(userPermissions);
}
